import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {IReelStoppedData, ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {RomanEmpireParsedGameData} from "../server/data/RomanEmpireParsedGameData";
import {TweenLite} from "gsap";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {RomanEmpireGameModuleConfig} from "../RomanEmpireGameModuleConfig";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireEvents} from "../events/RomanEmpireEvents";

import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ShakingDisplayObject} from "@nolimitcity/slot-game/bin/core/displayobject/ShakingDisplayObject";
import {RomanEmpireSoundConfig} from "../RomanEmpireSoundConfig";
import {RomanEmpireGameMode} from "../gamemode/RomanEmpireGameMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {SoundManager} from "../resource/sound/SoundManager";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class REReelStopPresentationController extends ReelStopPresentationController {
    private _scatterPos: number[];
    private _isScatterTriggered: boolean = false;
    private _landingReelIdAndSymId: number[][] = [];
    private _reelGrid: string[][] = [];
    public _stageShakeObject: any;
    private _isGenieFeatureTriggered: boolean = false;
    private _m3TriggeredReelId: number;
    private _isRandomBothWaysTriggered: boolean = false;
    private readonly symBolTodim: number[] = [0, 4];
    private _isReSpin: boolean = false;
    private _hasBetWin: boolean = false;
    private _scatterPosInReSpin: boolean[][] = [];
    private _scatterCounter: number = 0;
    private _newOverlayWilds: boolean[][] = [];
    private _isNoGenieReSpin: boolean = false;
    private _nearWinReels: boolean[] = [];
    private _lastAnticipationReelInReSpin: number;

    constructor(index: number, name?: string, tweakEnabled?: boolean, betWinMode?: BetWinMode) {
        super(index, "REReelStopPresentationController", tweakEnabled, betWinMode);
        this._stageShakeObject = new ShakingDisplayObject(StageManager.stage);
    }

    protected addFeatureEventHandlers(): void {
        super.addFeatureEventHandlers && super.addFeatureEventHandlers();
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, () => this.changeSymbolStateToNormal());
        // EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => {
        //
        // });
    }


    private setSymVisibility(reelController: ReelController) {
        if (reelController?.allSymbols.length) {
            for (let index = reelController?.allSymbols.length - 1; index > 0; index--) {
                const sym = reelController?.allSymbols[index];
                sym?.setVisibility(true);
            }
        }
    }

    /**
     * function to change symbol state to normal before spin.
     */
    private changeSymbolStateToNormal(): void {
        if (!this._hasBetWin) {
            for (let i = 0; i < 5; i++) {
                let noOfSymbols = Reels.allSymbols(i).length;
                for (let j = 0; j < noOfSymbols; j++) {
                    if (this.symBolTodim.indexOf(j) != -1) continue;
                    let symbol = Reels.allSymbols(i)[j];
                    if (symbol) {
                        symbol.changeState({
                            state: RomanEmpireGameConfig.instance.SYMBOL_STATES.normal,
                            fadeInDuration: 0,
                        });
                    }
                }

            }
        }
    }

    private playRandomFeatureWaysIntroSound() {
        Logger.logDev("playRandomFeatureWaysIntroSound");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.RANDOM_FEATURE_WAYS_INTRO);
    }

    protected parseFeatureGameData(data: RomanEmpireParsedGameData): void {
        Logger.logDev("expandingWild Logs : parseFeatureGameData");
        const reelController1 = Reels.getReel(1);
        const reelController3 = Reels.getReel(3);
        reelController1 && this.setSymVisibility(reelController1);
        reelController3 && this.setSymVisibility(reelController3);
        RomanEmpireGameModuleConfig.foregroundAnimation.stopExpandWildAnimation();
        this._lastAnticipationReelInReSpin = -1;
        this._scatterPos = data.scatterPositions || [];
        this._newOverlayWilds = data.newOverlayWilds;
        this._landingReelIdAndSymId = [];
        this._reelGrid = data.reels;
        this._isRandomBothWaysTriggered = data.isRandomBothWaysTriggered;
        this._isScatterTriggered = this._scatterPos.filter(value => value > -1).length > 2;
        this._isGenieFeatureTriggered = data.isGenieFeatureTriggered;
        this._isReSpin = data.mode === RomanEmpireGameMode.GENIE_RESPIN;
        this._isNoGenieReSpin = data.isNoGenieSpin;
        let betLineWinData = data.betWins;
        if (data?.bothWayWins?.length) {
            betLineWinData = data.betWins?.concat(data.bothWayWins);
        }
        this._hasBetWin = (betLineWinData != null && betLineWinData?.length > 0);
        data.newOverlayWilds.forEach((rowArr, colIndex) => {
            rowArr.forEach((val, rowIndex) => {
                if (this._lastAnticipationReelInReSpin == -1 && val) {
                    this._lastAnticipationReelInReSpin = colIndex;
                }
                this._scatterPosInReSpin[colIndex] = this._scatterPosInReSpin[colIndex] || [];
                this._scatterPosInReSpin[colIndex][rowIndex] = data.walkingWildsScatterPositions[colIndex][rowIndex] && !val;
            })
        });

        //Logger.log("expandingWild parseFeatureGameData", data);
        if (this._isRandomBothWaysTriggered) {
            RomanEmpireGameModuleConfig.foregroundAnimation.playExpandWildAnimation();
            this.playRandomFeatureWaysIntroSound();
        } else {
            // RomanEmpireGameModuleConfig.foregroundAnimation.stopExpandWildAnimation();
        }
        this._nearWinReels = data.nearWinReels;
        Logger.logDev("Last AnticipationReel In ReSpin : ", this._lastAnticipationReelInReSpin);
        this.calculateFrameHidglightPosition();
    }


    /**
     * function to calculate all the position of M2 and M3 coming adjacently
     * so that frame highlight animation should not be hide on that.
     */
    private calculateFrameHidglightPosition(): boolean[][] {
        this._m3TriggeredReelId = -1;
        let _stickyFramePos: boolean[][] = [];
        for (let i = 0; i < this._reelGrid.length; i++) {
            _stickyFramePos[i] = [false, false, false];
            for (let j = 0; j < this._reelGrid[i].length; j++) {
                if (i > 0 && this._reelGrid[i][j] === "M3" && this._reelGrid[i - 1][j] === "M2") {
                    if (!(this._isReSpin && (this._scatterPosInReSpin[i][j] || this._scatterPosInReSpin[i - 1][j]))) {
                        _stickyFramePos[i][j] = true;
                        _stickyFramePos[i - 1][j] = true;
                    }
                    this._m3TriggeredReelId = i;
                }
            }
        }
        RomanEmpireGameModuleConfig.foregroundAnimation._stickyFrame = _stickyFramePos;
        return _stickyFramePos;
    }

    private playLandingSound(data: IReelStoppedData) {
        if (this._isRandomBothWaysTriggered) {
            (data.reelId !== 1 && data.reelId !== 3) && SoundManager.playSound(RomanEmpireSoundConfig.instance.REEL_LANDING + (data.reelId + 1));
            return;
        }

        if (this._isReSpin && this._gameData?.nextMode == RomanEmpireGameMode.NORMAL) {
            SoundManager.playSound(RomanEmpireSoundConfig.instance.REEL_LANDING + (data.reelId + 1));
            return;
        }

        if (((data.fastSpin || data.quickStop) && (data.reelId === 0 || data.reelId === 2 || data.reelId === 4))) {
            SoundManager.playSound(RomanEmpireSoundConfig.instance.REEL_LANDING + (data.reelId + 1));
        } else if ((!data.fastSpin && !data.quickStop)) {
            SoundManager.playSound(RomanEmpireSoundConfig.instance.REEL_LANDING + (data.reelId + 1));
        }
    }

    private playScatterSound(data: IReelStoppedData) {
        if (this._isReSpin) {
            this._newOverlayWilds[data.reelId].forEach((isScatter, index) => {
                if (isScatter) {
                    const sym = Reels.getSymbol(data.reelId, index);
                    if (sym && (sym.symName != "M2" && sym.symName != "M3")) {
                        SoundManager.playSound(this._nearWinReels.indexOf(true) != -1 ? RomanEmpireSoundConfig.instance.FS_SCATTER_LAST_SPIN : RomanEmpireSoundConfig.instance.SCATTER_FS);
                        Logger.logDev("playScatterSound " + (this._nearWinReels.indexOf(true) != -1 ? "FS_SCATTER_LAST_SPIN" : "SCATTER_FS"));
                    }
                }
            });
        } else {
            (this._nearWinReels.indexOf(true) != -1 || data.reelId < 3) && this._reelGrid[data.reelId].forEach((symName, index) => {
                //TODO
                if (symName === "S") {
                    this._scatterCounter++;
                    SoundManager.playSound(RomanEmpireSoundConfig.instance.SCATTER + Math.min(this._scatterCounter, 3));
                    Logger.logDev("playScatterSound", Math.min(this._scatterCounter, 3));
                }
            });
        }
    }


    private stopRandomBaseFeatureSound(data: IReelStoppedData) {
        if (this._isRandomBothWaysTriggered && data.reelId == 4) {
            SoundManager.stopSound(RomanEmpireSoundConfig.instance.RANDOM_FEATURE_WAYS_INTRO);
            SoundManager.playSound(RomanEmpireSoundConfig.instance.RANDOM_FEATURE_WAYS_ENDS);
        }
    }

    private stopAnticipationSounds() {
        Logger.logDev("anticipationSound stopAnticipationSounds");
        SoundManager.stopSound(RomanEmpireSoundConfig.instance.SCATTER_ANTICIPATION);
        SoundManager.fadeSound(this._isReSpin ? RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS : RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 1500, 1);
    }

    private playAnticipationFinalSound() {
        if (this._isReSpin) {
            this._lastAnticipationReelInReSpin == -1 && SoundManager.playAnticipationFail();
        } else {
            this._isScatterTriggered ? SoundManager.playAnticipationSuccess() : SoundManager.playAnticipationFail()
        }
    }

    public onReelBounce(data: IReelStoppedData): void {
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_REEL_BOUNCE, data));
        // added this if {} & else if {} to play reel Landing sound #158
        this.playLandingSound(data);
        this.playScatterSound(data);
        this.stopRandomBaseFeatureSound(data);
        if (this._nearWinReels.indexOf(true) != -1) {
            if (this._isReSpin && this._lastAnticipationReelInReSpin != -1) {
                this._lastAnticipationReelInReSpin == data.reelId && this.stopAnticipationSounds();
            } else {
                data.reelId == 4 && this.stopAnticipationSounds();
            }
            data.reelId == 4 && this.playAnticipationFinalSound();
        }


        // added this delay to smoothly show and hide landing animation+
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.HIDE_SCATTER_ANTICIPATION_ANIM, data.reelId),); // event to hide scatter anticipation
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.PLAY_SCATTER_ANTICIPATION_ANIM, data.reelId + 1)); // event to play scatter anticipation on next reel
        if (!data.fastSpin && !data.quickStop) {
            TweenLite.delayedCall(0.2, () => {
                data.reelId < 4 && this.playLandingAnimation(data);
            });
        } else {
            data.reelId < 4 && this.playLandingAnimation(data);
        }
        const reelController = Reels.getReel(data.reelId);
        if (reelController?.allSymbols.length) {
            reelController?.allSymbols.forEach((sym, index) => {
                if (sym!.symName === "M1") { // to Fix #67
                    reelController && reelController.moveSymbolToTop(index - RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[0]);
                }
            });
            for (let index = reelController?.allSymbols.length - 1; index > 0; index--) {
                const sym = reelController?.allSymbols[index];
                if (sym!.symName === "S") {
                    reelController && reelController.moveSymbolToTop(index - RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[0]);
                }
                if (this._isRandomBothWaysTriggered && (data.reelId == 1 || data.reelId == 3)) {
                    sym?.setVisibility(false);
                }
            }
        }
    }

    public onReelSpinStopped(data: IReelStoppedData): void {
        if (this._isReSpin) {
            const symIndex: number = RomanEmpireGameModuleConfig.foregroundAnimation._stickyFrame[data.reelId].indexOf(true);
            if (symIndex != -1) {
                const sym = Reels.getSymbol(data.reelId, symIndex);
                if (sym?.symName == "M3") {
                    Logger.logDev("play M2M3 Lock sound in respin");
                    SoundManager.playSound(RomanEmpireSoundConfig.instance.RFB_LOCK);
                }
            }
        }
        for (let i = 0; i < this.symBolTodim.length; i++) { // added this to fix #105 (disable symbol if appear outside the reel area)
            let symbol = Reels.allSymbols(data.reelId)[this.symBolTodim[i]];
            if (symbol) {
                symbol.changeState({
                    state: RomanEmpireGameConfig.instance.SYMBOL_STATES.noWin,
                    fadeInDuration: 0,
                });
            }
        }

        // added this check to clear landing animation from previous reels.
        //if (data.reelId > 0) {

        RomanEmpireGameModuleConfig.foregroundAnimation.clearLandingAnimContainers(this._landingReelIdAndSymId);
        //}
        if (data.reelId == 4 && ((this._scatterPos[4] != -1 && this._isScatterTriggered))) {
            //Delay added for last row scatter trigger animation
            let delay: number = 0.5
            TweenLite.to({}, delay, {
                onComplete: () => {
                    this.dispatchCompleteEvent(data.reelId);

                }
            });
        } else {
            this.dispatchCompleteEvent(data.reelId);
        }
        data.reelId == 4 && (this._scatterCounter = 0);
    }

    /**
     * function to play Landing Animations on Symbol
     * whenever M2 will land there will be landing
     * for M3 landing  there has to be landing of m2 on previous reel on same index M3 lands.
     * @param data
     */
    private playLandingAnimation(data: IReelStoppedData): void {
        if (this._isRandomBothWaysTriggered) {
            return;
        }
        let reel = this._reelGrid[data.reelId];
        reel?.forEach((symbol, index) => {
            if ((symbol.indexOf("M2") !== -1) || (data.reelId > 0 && symbol.indexOf("M3") !== -1 && this._reelGrid[data.reelId - 1][index] === "M2")) {
                this._landingReelIdAndSymId.push([data.reelId, index]);
                if (!(this._isReSpin && this._scatterPosInReSpin[data.reelId][index])) { //to fix #219
                    RomanEmpireGameModuleConfig.foregroundAnimation.playLandingFrameAnimation(data.reelId, index);
                }
            }
        });
    }
}